import { Injectable } from "@angular/core";
import { EndpointsService, NotificationService } from "../core/services";
import { Http, Response } from "@angular/http";
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

@Injectable()
export class BrandStatisticsService {
    private static notificationService;
    constructor(
        private http: Http,
        private endpoints: EndpointsService,
        private notificationService: NotificationService) {
        BrandStatisticsService.notificationService = notificationService;
    }

    public getBrandStatistics(sortField: number, sortAsc: boolean, pageNumber: number, pageSize: number, brandName: string, mediaFileName: string): Observable<Response> {
        return this.http.get(this.createBrandStatisticsUrl(sortField, sortAsc, pageNumber, pageSize, brandName, mediaFileName))
            .catch(this.handleError);
    }

    public removeBrandToAdAssociation(brandMediaFile: string) {
        return this.http.delete(this.endpoints.REMOVE_BRAND_TO_AD_ASSOCIATION + "?mediaFile=" + brandMediaFile);
    }

    public requestNewAdTrailerForMediaFile(mediaFile: string) {
        return this.http.get(`${this.endpoints.GENERATE_AD_TRAILER}?mediaFile=${mediaFile}`)
            .catch(this.handleError);
    }

    public getAdtrailerInfo(mediaFile: string) {
        return this.http.get(`${this.endpoints.GET_AD_TRAILER}?mediaFile=${mediaFile}`)
        .catch(this.handleError);
    }

    private createBrandStatisticsUrl(sortField: number, sortAsc: boolean, pageNumber: number, pageSize: number, brandName: string, mediaFileName: string) {
        return `${this.endpoints.GET_BRANDS_STATISTICS_LIST_URL}?sortFieldId=${sortField}&sortAsc=${sortAsc}&pageNumber=${pageNumber}&pageSize=${pageSize}&brandName=${brandName}&mediaFileName=${mediaFileName}`;
    };

    handleError(error: Response): Observable<Response> {
        if (error.status === 400)
            BrandStatisticsService.notificationService.showError(error.json().message)
        else
            BrandStatisticsService.notificationService.showError();
        return Observable.throw(error.json().error || 'Server Error');
    }
}


// WEBPACK FOOTER //
// ./src/app/brand-statistics/brand-statistics.service.ts